<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 监控中心 </el-breadcrumb-item>
          <el-breadcrumb-item>调控管理</el-breadcrumb-item>
          <el-breadcrumb-item>编辑计划详细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="编辑调控" name="account">
            <el-form
              ref="ruleForm2"
              style="margin-top: 20px"
              :label-position="labelPosition"
            >
              <el-form-item
                label="柜子编码"
                label-width="200px"
                prop="planLoad"
              >
                <el-input
                  v-model="cabinetCode"
                  :disabled="true"
                  style="width: 150px"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="tab-content" style="padding: 0">
              <el-form
                ref="ruleForm"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
              >
                <el-form-item
                  label="计划调控负荷（单位:KW）"
                  label-width="200px"
                  prop="planLoad"
                >
                  <el-input
                    v-model="model.planLoad"
                    style="width: 150px"
                  ></el-input>
                  <div style="width: 150px; margin: 0 auto">
                    <span class="span-info-text"
                      >* 负数表示充电:-100表示100kw充电</span
                    >
                    <span class="span-info-text">* 0表示不充不放</span>
                    <span class="span-info-text"
                      >* 正数表示放电,100表示100kw放电</span
                    >
                  </div>
                </el-form-item>
                <el-form-item label="开始时间" label-width="200px">
                  <el-time-picker
                    v-model="model.startTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:01',
                      end: '23:59',
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                    value-format="HH:mm"
                    format="HH:mm"
                    placeholder="选择时间"
                  >
                  </el-time-picker>
                </el-form-item>
                <el-form-item label="结束时间" label-width="200px">
                  <el-time-picker
                    v-model="model.endTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:01',
                      end: '23:59',
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="选择时间"
                  >
                  </el-time-picker>
                </el-form-item>
                <!-- <el-form-item label="计划时间" label-width="200px">
                  <el-date-picker
                    style="width: 220px"
                    v-model="model.planTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                  >
                  </el-date-picker>
                </el-form-item> -->
              </el-form>
            </div>
            <!-- <div
              v-if="data.length > 0"
              style="display: flex; justify-content: space-around"
            >
              <div>
                <span class="span-info-text"
                  >* 负数表示充电:-100表示100kw充电</span
                >
                <span class="span-info-text">* 0表示不充不放</span>
                <span class="span-info-text"
                  >* 正数表示放电,100表示100kw放电</span
                >
              </div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div class="tab-content" v-if="true">
              <div
                style="display: flex; justify-content: space-around"
                v-for="(item, index) in data"
                :key="index"
              >
                <div style="display: flex; flex-direction: column">
                  <span style="width: 200px; margin-bottom: 5px"
                    >计划调控负荷（单位:KW）</span
                  >
                  <el-input v-model="item.planLoad"></el-input>
                </div>
                <div style="display: flex; flex-direction: column">
                  <span style="width: 100px; margin-bottom: 5px">开始时间</span>
                  <el-time-picker
                    v-model="item.startTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:01',
                      end: '23:59',
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                    value-format="HH:mm"
                    format="HH:mm"
                    placeholder="选择时间"
                  >
                  </el-time-picker>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 20px;
                  "
                >
                  <span style="width: 100px; margin-bottom: 5px">结束时间</span>
                  <el-time-picker
                    v-model="item.endTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:01',
                      end: '23:59',
                      selectableRange: '00:00:00 - 23:59:59',
                    }"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="选择时间"
                  >
                  </el-time-picker>
                </div>
                <el-button
                  style="width: 70px; height: 40px; margin-top: 20px"
                  type="danger"
                  icon="el-icon-delete"
                ></el-button>
              </div>
              <el-button type="primary" @click="add()" style="margin-top: 20px"
                >添加</el-button
              >
            </div> -->
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确认保存</el-button
          >
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";

export default {
  data() {
    const validateTwoDecimals = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入调控负荷"));
      } else if (!/^-?\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("调控负荷只能输入最多两位小数和数字"));
      } else {
        callback();
      }
    };
    return {
      cabinetCode: "",
      flag: true,
      disabled: true,
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      data: [],
      companyList: [], //公司列表
      form: {
        startTime: null,
        endTime: null,
      },
      cabinetList: [],
      model: {
        id: "",
        planId: "",
        planLoad: "",
        startTime: "",
        endTime: "",
        planTime: "",
        source: "Fx",
      },
      type: 0, //1复制 2修改
      rules: {
        planLoad: [
          { required: true, message: "请输入调控负荷", trigger: "blur" },
          { validator: validateTwoDecimals, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    add() {
      this.data.push({
        id: "",
        planId: this.model.planId,
        planLoad: "",
        startTime: "",
        endTime: "",
        planTime: this.model.planTime,
        source: "Fx",
      });
    },
    submitForm: function (formName) {
      let _this = this; //当前页面

      _this.cabinetList.forEach((item) => {
        if (item.id == _this.model.deviceId) {
          _this.model.equipNo = item.cabinetCode;
        }
      });
      // if (this.flag) {
      console.log(this.model);
      // } else {
      //   // this.$refs[formName].validate((valid) => {
      //   //   if (valid) {
      //   //     if (JSON.stringify(this.$route.params) !== "{}") {
      //   //       AxiosAjax({
      //   //         url: "/cabinet/haiyi/plan/detail/update",
      //   //         method: "post",
      //   //         data: _this.model,
      //   //         loading: true,
      //   //         success: function (res) {
      //   //           console.log(res.data.code);
      //   //           setTimeout(() => {
      //   //             window.history.back(-1);
      //   //           }, 100);
      //   //           if (res.data.code == "000000") {
      //   //             _this.$message({
      //   //               message: "修改成功",
      //   //               type: "success",
      //   //             });
      //   //           }
      //   //         },
      //   //       });
      //   //     }
      //   //   }
      //   // });
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (JSON.stringify(this.$route.params) !== "{}") {
            AxiosAjax({
              url: "/cabinet/haiyi/plan/detail/update",
              method: "post",
              data: _this.model,
              loading: true,
              success: function (res) {
                console.log(res.data.code);
                setTimeout(() => {
                  window.history.back(-1);
                }, 100);
                if (res.data.code == "000000") {
                  _this.$message({
                    message: "修改成功",
                    type: "success",
                  });
                }
              },
            });
          } else {
            AxiosAjax({
              url: "/cabinet/haiyi/plan/detail",
              method: "post",
              data: _this.model,
              loading: true,
              success: function (res) {
                console.log(res.data.code);
                if (res.data.code == "000000") {
                  setTimeout(() => {
                    window.history.back(-1);
                  }, 100);
                  _this.$message({
                    message: "新增成功",
                    type: "success",
                  });
                }
              },
            });
          }
        } else {
          _this.$message({
            message: "请检查输入项",
            type: "error",
          });
          return false;
        }
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
  },
  mounted: function () {
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.model = this.$route.params;
      this.cabinetCode = this.$route.params.equipNo;
    }
    if (this.$route.query.id) {
      this.model.planId = this.$route.query.id;
      this.flag = true;
      this.model.planTime = this.$route.query.planTime;
      this.cabinetCode = this.$route.query.cabinetCode;
    } else {
      this.flag = false;
    }
  },
};
</script>
<style scoped>
.dl-box-fee .el-input {
  width: 20%;
}
.dl-box-fee /deep/ .el-form-item__label {
  min-width: 80px;
}
.dl-box .el-form-item__label {
  font-weight: bold;
}
.el-date-editor.el-input {
  width: 150px;
}
.myselect .el-input {
  width: 100px;
}
.card-form {
  display: flex;
}
.card-form /deep/ .el-col {
  flex: 1;
}
/deep/ .el-form-item__error {
  position: static;
}
.span-info-text {
  color: #e6a23c;
  display: block;
  height: 25px;
  width: 400px;
  line-height: 25px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Regulation/PlanEdit.vue